var ResolvableLanguageElementAttributes;
(function (ResolvableLanguageElementAttributes) {
    ResolvableLanguageElementAttributes["Language"] = "language";
    ResolvableLanguageElementAttributes["Lang"] = "lang";
    ResolvableLanguageElementAttributes["DataLanguage"] = "data-language";
    ResolvableLanguageElementAttributes["DataLang"] = "data-lang";
})(ResolvableLanguageElementAttributes || (ResolvableLanguageElementAttributes = {}));
export default ResolvableLanguageElementAttributes;
//# sourceMappingURL=ResolvableLanguageElementAttributes.js.map